import * as React from "react";
import LoadObject from "../../load_objects/LoadObject";
import {Fixture} from "../records/Fixture";
import {FixturesListView} from "./FixturesListView";
import TextField from '@material-ui/core/TextField';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import IconButton from "@material-ui/core/IconButton";
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import {Moment} from "moment";
import Checkbox from "@material-ui/core/Checkbox";

export interface IFixturesPageViewProps {
    fixtureLoader: LoadObject<Fixture>;
    getFixtures: (from: number, to: number, requestId: string) => void;
}

export interface IFixturesPageViewState {
    live: boolean;
    finished: boolean;
    searchString: string;
    date: Moment;
    fixtures: Array<Fixture>
    filteredFixtures: Array<Fixture>,
    dateChangeTimeout: any
}

export class FixturesPageView extends React.Component<IFixturesPageViewProps, IFixturesPageViewState> {

    public static readonly DATECHANGE_DEBOUNCE: number = 100;

    constructor(props: any)
    {
        super(props);
        this.state = this.getInitialState();
    }

    private getInitialState()
    {
        return {
            live: false,
            finished: false,
            searchString: "",
            date: moment(),
            fixtures: [],
            filteredFixtures: [],
            dateChangeTimeout: undefined
        }
    }

    public componentWillReceiveProps(newProps)
    {
        let fixtureLoader = newProps.fixtureLoader;

        if (!fixtureLoader.isLoading() && !fixtureLoader.isUpdating() && fixtureLoader.getValue())
        {
            //this.filterFixtures(fixtureLoader.getValue().fixtures);
            this.setState({
                fixtures: fixtureLoader.getValue().fixtures
            });
            this.filterFixtures(fixtureLoader.getValue().fixtures,
                                this.state.live,
                                this.state.finished,
                                this.state.searchString);
        }
    }

    private filterFixtures(fixtures, live, finished, searchString)
    {
        fixtures = fixtures.filter(function(fix) {
            let res = true;
            let status = fix.status;

            if (live)
            {
                res = res && (status == "Started");
            }
            else if (finished)
            {
                res = res && (status == "Ended");
            }

            if (searchString != null && searchString != "")
            {
                let team1Name = fix.participants[0].name || "";
                let team2Name = fix.participants[1].name || "";
                let compName = fix.competition.name;
                let sport = fix.sport.name;
                let sportAlias = fix.sport.alias;
                let id = fix.id;

                let regex = new RegExp(searchString, 'i');

                res = res && (team1Name.match(regex) ||
                            team2Name.match(regex) ||
                            compName.match(regex) ||
                            sport.match(regex) ||
                            sportAlias.match(regex) ||
                            searchString === String(id));
            }

            return res;
        });

        this.setState({
            filteredFixtures: fixtures
        })
    }

    private getFixtures(newDate)
    {
        this.props.getFixtures(newDate.startOf('day').valueOf(), newDate.endOf('day').valueOf(), FixturesPageView.randomId());
    }

    private onDateChanged(newDate)
    {
        clearInterval(this.state.dateChangeTimeout);
        const timeout = setTimeout(() => this.getFixtures(newDate), FixturesPageView.DATECHANGE_DEBOUNCE)
        this.setState({
            date: newDate,
            dateChangeTimeout: timeout
        }); 
    }

    private onSearchChanged(evt)
    {
        // TODO does filters have an effect on the list? If no, reapply with filters.
        this.setState({
            searchString: evt.target.value
        });

        this.filterFixtures(this.state.fixtures, this.state.live, this.state.finished, evt.target.value)
    }

    private prevDay()
    {
        let currentDate = this.state.date;
        let newDate = currentDate.subtract(1, 'days');

        clearInterval(this.state.dateChangeTimeout);
        const timeout = setTimeout(() => this.getFixtures(newDate), FixturesPageView.DATECHANGE_DEBOUNCE)
        this.setState({
            date: newDate,
            dateChangeTimeout: timeout
        });        
    }

    private nextDay()
    {
        let currentDate = this.state.date;
        let newDate = currentDate.add(1, 'days');

        clearInterval(this.state.dateChangeTimeout);
        const timeout = setTimeout(() => this.getFixtures(newDate), FixturesPageView.DATECHANGE_DEBOUNCE)
        this.setState({
            date: newDate,
            dateChangeTimeout: timeout
        }); 
    }

    private handleLiveChanged(evt)
    {
        let liveChecked = evt.target.checked;
        let finishedChecked = this.state.finished;

        if(liveChecked)
        {
            finishedChecked = false;
        }

        this.setState({
            live: liveChecked,
            finished: finishedChecked
        });

        this.filterFixtures(this.state.fixtures, liveChecked, finishedChecked, this.state.searchString);
    }

    private handleFinishedChanged(evt)
    {
        let finishedChecked = evt.target.checked;
        let liveChecked = this.state.live;

        if(finishedChecked)
        {
            liveChecked = false;
        }

        this.setState({
            finished: finishedChecked,
            live: liveChecked
        });

        this.filterFixtures(this.state.fixtures, liveChecked, finishedChecked, this.state.searchString);
    }

    public static randomId() : string { 
        return Date.now().toString(36) + Math.random().toString(36).substring(2); 
    }

    public render()
    {
        let liveToggleStyle = {
            border: "2px solid",
            padding: "5px 10px 5px 10px"
        };
        let finishToggleStyle = {
            border: "2px solid",
            padding: "5px 10px 5px 10px"
        };

        if (this.state.live)
        {
            liveToggleStyle = {
                border: "3px solid red",
                padding: "5px 10px 5px 10px"
            }
        }
        if (this.state.finished)
        {
            finishToggleStyle = {
                border: "3px solid blue",
                padding: "5px 10px 5px 10px"
            }
        }

        return (

            <div className="fixture-list-page">
                <div className="fixture-filter-bar">
                    <div className={"liveFilter"}>
                        <Checkbox
                            style={{textAlign: "center", fontSize: "17px", fontWeight: "bold", marginTop: "5px", width: "60px"}}
                            checked={this.state.live}
                            onChange={this.handleLiveChanged.bind(this)}
                            indeterminateIcon={<div style={liveToggleStyle}>Live</div>}
                            indeterminate/>
                    </div>

                    <div className={"finishedFilter"}>
                        <Checkbox
                            style={{textAlign: "center", fontSize: "17px", fontWeight: "bold", marginTop: "5px", width: "100px"}}
                            checked={this.state.finished}
                            onChange={this.handleFinishedChanged.bind(this)}
                            indeterminateIcon={<div style={finishToggleStyle}>Finished</div>}
                            color={"primary"}
                            indeterminate/>
                    </div>

                    <div className="dateFilter">
                        <IconButton
                            className={"inline-block"}
                            onClick={this.prevDay.bind(this)}>
                            <ChevronLeft/>
                        </IconButton>
                        <div className={"datepickWrapper"}>
                            <DatePicker
                                selected={this.state.date}
                                dateFormat={"Do MMMM YYYY"}
                                onChange={this.onDateChanged.bind(this)}>
                            </DatePicker>
                        </div>
                        <IconButton
                            className={"inline-block"}
                            onClick={this.nextDay.bind(this)}>
                            <ChevronRight/>
                        </IconButton>
                    </div>

                    <div className="searchBar">
                        <TextField
                            fullWidth
                            id="search"
                            label="Search for sport, team or competition"
                            type="search"
                            margin="normal"
                            onChange={this.onSearchChanged.bind(this)}/>
                    </div>
                </div>

                <div className="fixture-list-wrapper">
                    <FixturesListView fixtureLoader={this.props.fixtureLoader} fixtures={this.state.filteredFixtures}/>
                </div>
            </div>
        )
    }
}